import { EventManager } from 'utils/event_manager';
import './index.scss';
export default class Item {
  constructor(context) {
    this.$context = $(context);
    this.replyId = this.$context.data().replyId;
    this.commentId = this.$context.data().commentId;
    this.$btnDelete = $('.js-delete-replies-btn', this.$context);
    this.$btnEdit = $('.js-edit-replies-btn', this.$context);

    this._bindSend();
    this._bindEdit();
  }

  _bindSend() {
    this.$btnDelete.on('click', e => {
      e.preventDefault();

      EventManager.publish(`commentReply.${this.commentId}.delete`, {
        replyId: this.replyId
      });
    });
  }

  _bindEdit() {
    this.$btnEdit.off('click').on('click', e => {
      e.preventDefault();
      const commentHTML = $('.js-question-reply-text', this.$context).html();

      EventManager.publish(`commentReply.${this.commentId}.populateEditor`, {
        commentHTML,
        replyId: this.replyId
      });
    });
  }
}
